import { Link } from "react-router-dom";
import "../styles/components/footer.scss";
import { FaWhatsapp, FaInstagram, FaTiktok } from "react-icons/fa";
import { WHATSAPP_NUMBER, WHATSAPP_DEFAULT_MESSAGE } from "../constants/contact";
import luma3dLogo from "../assets/luma3d-logo.png";

const INSTAGRAM_URL = "https://instagram.com/luma3d_lab";
const TIKTOK_URL = "https://www.tiktok.com/@luma3d_lab0";

function Footer() {
  const waText = encodeURIComponent(WHATSAPP_DEFAULT_MESSAGE);
  const waLink = `https://wa.me/${WHATSAPP_NUMBER}?text=${waText}`;

  return (
    <footer className="footer">
      <div className="footer-wrap">
        <div className="footer-top">
          {/* Brand column */}
          <div className="f-col brand-col">
            <img
              className="footer-logo"
              src={luma3dLogo}
              alt="Luma3D"
              loading="lazy"
            />

            <p className="desc">
              Premium 3D printing marketplace. Crafted for luxury products,
              precision, and style.
            </p>

            <div className="cta-row">
              <a className="cta wa" href={waLink} target="_blank" rel="noreferrer">
                <FaWhatsapp className="ico wa-ico" />
                WhatsApp
              </a>

              <a className="cta ig" href={INSTAGRAM_URL} target="_blank" rel="noreferrer">
                <FaInstagram className="ico ig-ico" />
                Instagram
              </a>

              <a
                className="cta tt"
                href={TIKTOK_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaTiktok className="ico tt-ico" />
                TikTok
              </a>
            </div>
          </div>

          {/* Explore column */}
          <div className="f-col">
            <h4>Explore</h4>
            <Link to="/categories">Categories</Link>
            <Link to="/cart">Cart</Link>
            <Link to="/checkout">Checkout</Link>
          </div>

          {/* Contact column — hidden on mobile (duplicates the brand CTA row) */}
          <div className="f-col contact-col">
            <h4>Contact</h4>
            <a href={waLink} target="_blank" rel="noreferrer">
              <FaWhatsapp className="link-ico wa-ico" /> Chat on WhatsApp
            </a>
            <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer">
              <FaInstagram className="link-ico ig-ico" /> Visit Instagram
            </a>
            <a href={TIKTOK_URL} target="_blank" rel="noopener noreferrer">
              <FaTiktok className="link-ico tt-ico" /> Follow on TikTok
            </a>
            <span className="hint">Support hours: 10:00 – 18:00</span>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2026 Luma3D. All rights reserved.</p>
          <p className="mini">
            Designed for a luxury experience — <span>crafted with care</span>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;